import ZendeskTicketCell from './container';

export default ZendeskTicketCell;
